import axios from 'axios'

const apiUrl = process.env.API_URL

export function summonerByName (name, region, includes = [], queue = 'RANKED_SOLO_5x5', page = 1) {
  let path = `${apiUrl}/api/${region}/${name}`
  let params = {
    queue,
    include: includes.join(','),
    page,
  }

  return axios.get(path, { params })
}

export function leaguePointsHistory (name, region, queue = 'RANKED_SOLO_5x5', currentSeason = true) {
  let range = currentSeason ? 'current-season' : ''
  let path = `${apiUrl}/api/${region}/${name}/league-points-history/${range}`

  return axios.get(path, { params: { queue } })
}

export function forceLeagueUpdate (name, region) {
  let path = `${apiUrl}/api/${region}/${name}/league-position-update`

  return axios.post(path)
}



// WEBPACK FOOTER //
// ./src/api/index.js